import { render, staticRenderFns } from "./DeleteCompanyTransaction.vue?vue&type=template&id=e1f6e3c0"
import script from "./DeleteCompanyTransaction.vue?vue&type=script&lang=js"
export * from "./DeleteCompanyTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports